import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['toggle', 'content'];

  static values = {
    activeClasses: {
      type: Array,
      default: ['bg-white', 'text-blue-600', 'shadow'],
    },
  };

  connect() {
    // Find first tab with content
    const tabWithContent = this.toggleTargets.find((toggle) => toggle.dataset.hasContent === 'true');

    if (tabWithContent) {
      this.activate(tabWithContent);
    }

    // Set initial text colors based on count
    this.toggleTargets.forEach((toggle) => {
      const matches = toggle.textContent.match(/\((\d+)\)/);
      const count = matches ? parseInt(matches[1], 10) : 0;
      if (count === 0) {
        toggle.classList.add('text-gray-400');
      }
    });
  }

  switch(event) {
    const toggle = event.currentTarget;
    if (toggle.disabled) return;
    this.activate(toggle);
  }

  activate(toggle) {
    // Remove active classes from all toggles and reset text colors
    this.toggleTargets.forEach((elem) => {
      this.activeClassesValue.forEach((cls) => elem.classList.remove(cls));
      elem.classList.remove('text-gray-400', 'text-blue-600');

      // Set text color based on count
      const matches = elem.textContent.match(/\((\d+)\)/);
      const count = matches ? parseInt(matches[1], 10) : 0;
      if (count === 0) {
        elem.classList.add('text-gray-400');
      }
    });

    // Add active classes to current toggle
    if (!toggle.disabled) {
      this.activeClassesValue.forEach((cls) => toggle.classList.add(cls));
    }

    // Show current content and hide others
    const { tabId } = toggle.dataset;
    this.contentTargets.forEach((content) => {
      content.classList.toggle('hidden', content.id !== tabId);
    });
  }
}
